import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var align_justify_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M4 12.8h16v-1.5H4v1.5zm0 7h12.4v-1.5H4v1.5zM4 4.3v1.5h16V4.3H4z" }) });
export {
  align_justify_default as default
};
//# sourceMappingURL=align-justify.js.map
